<template>
  <div style="text-align: center; font-size: 0.85rem;">

    <p v-if="!match">
      Not scheduled
    </p>

    <p v-if="match && match.result">
      {{ match.result[winner()] }} - {{ match.result[loser()] }}
    </p>

    <p v-if="match && !match.result">
      <span v-if="match.scheduledTime">{{ match.scheduledTime }}</span>
      <span v-if="!match.scheduledTime"> {{ matchIdentifier() }}</span>
    </p>

  </div>
</template>

<script>
  export default {
    name: 'EliminationMatchInfo',
    props: {
      match: [ Object ]
    },

    methods: {
      winner() {
        return (this.match.result ? this.match.result.winner : undefined);
      },

      loser() {
        if (this.match.result) {
          let propertyNames = Object.keys(this.match.result);
          for (let property of propertyNames) {
            if (property != this.match.result.winner && property !== 'winner') {
              return property;
            }
          }
        }

        return undefined;
      },

      matchIdentifier() {
        if (this.match.identifier.endsWith('3rd')) {
          return '3rd place match';
        }

        let round = this.match.identifier.substring(this.match.identifier.indexOf('-') + 1);
        let key = round.substring(round.indexOf('-') + 1);
        round = round.substring(0, round.indexOf('-'));

        return 'Round ' + round + ' #' + key;
      }
    }
  }
</script>

<style scoped>
</style>
